import { useMsal } from "@azure/msal-react";

const useLogout = () => {
  const { instance, accounts } = useMsal();

  return () => {
    const account = instance.getActiveAccount() || accounts[0] || null;
    instance.logoutRedirect({
      account,
      mainWindowRedirectUri: "/",
      postLogoutRedirectUri: "/",
    });
  };
};

//const useLogout = () => {

// const userInfo = useUserInfoQuery({});
// const { instance } = useMsal();
// const accountInfo = useAccount({ localAccountId: userInfo?.data?.sub });

// return () => {
//   const logoutRequest = {
//     account: instance.getAccountByHomeId(accountInfo?.homeAccountId),
//     mainWindowRedirectUri: "/",
//     postLogoutRedirectUri: "/",
//   };
//   if (accountInfo?.homeAccountId) {
//     instance.logoutRedirect(logoutRequest);
//   }
// };
//};

export default useLogout;
